import { IUserContext } from './components/user_context_provider';
import { experimentBucket } from './user_context_helpers';
import { formatExperimentsForEventAttributes } from './elog/mparticle';
import { trackEvent } from './elog/mparticle_tracker';
import { MParticleEventName } from './elog/mparticle_types';
import { CommonsCmsDynamicPage } from './rql';

interface Props {
  componentData: CommonsCmsDynamicPage.Components;
}

export default function trackCmsExperimentComponentFilter(props: Props & IUserContext) {
  if (!props.componentData.experimentKey) { return true; }

  trackEvent({
    eventName: MParticleEventName.CmsExperimentQualifyingEvent,
    componentName: props.componentData.componentType,
    experiments: formatExperimentsForEventAttributes(props.user, [
      props.componentData.experimentKey,
    ]),
  });

  if (experimentBucket(props.user, props.componentData.experimentKey) === props.componentData.experimentBucket) {
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/track_cms_experiment_component_filter.tsx